module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注",
      "rows": 10,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.curdForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "remark", $$v)
      },
      expression: "curdForm.remark"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeRemarkDialog
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c67ea0d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/timetableManage/arrange/remark.vue
// module id = 1894
// module chunks = 502